const AtomicWarUrl={
host:"https://game3.jyzdianjing.com/sr", 
//host:"https://test.atomicgaming.net/pay/sr", 
//host:"http://192.168.3.2:8008/pay/sr", 
    player:(project,steamId)=>`/order/player/${project}/${steamId}`,
    recharge:"/order/order",
    status:(orderId)=>`/order/status/${orderId}`,
    wechat:(orderId)=>`/wechat/do/${orderId}`,
    alipay:(orderId)=>`/alipay/do/${orderId}`,
    paypal:(orderId)=>`/paypal/do/${orderId}`,
    payssion:(orderId,pmId)=>`/payssion/do/${orderId}?pmId=${pmId}`,
}

function GetUrl(game){
    let gameUrl = {}; 
    gameUrl = AtomicWarUrl; 
    return gameUrl
}

export default GetUrl;